import { ref } from 'vue';
import { captureRcsConsentApi } from '@Api/dashboard.api';

export function useRcsConsent() {
    const isCapturing = ref(false);
    const error = ref<string | null>(null);

    const captureConsent = async (participantId: string, messagingOptIn: boolean): Promise<boolean> => {
        isCapturing.value = true;
        error.value = null;
        try {
            await captureRcsConsentApi(participantId, messagingOptIn);
            return true;
        } catch (e) {
            error.value = e instanceof Error ? e.message : 'Failed to capture consent';
            return false;
        } finally {
            isCapturing.value = false;
        }
    };

    return {
        captureConsent,
        isCapturing,
        error,
    };
}
